export default __webpack_public_path__ + "static/media/company-links.06b43d01.svg";